import { Button, Input, Modal } from 'antd';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { postSubscription, postPayuSubscription, hoursCount, storeSubscription } from '../../actions/profile'
import { setSubscriptionSelectedTab, getUserProfileDetails } from 'actions/profileNew';
import { postCashfreeOrder } from 'actions/fees';
import { Api } from "services";
import { redirectToPayU, openPayuLoadingWindow } from 'pages/profile/paymentGateway';
import PaymentDetailsModal, { getMissingPaymentDetails, formatBillingAddress } from 'components/paymentDetailsModal';

const PAYU_WINDOW_NAME = 'payuPaymentWindow';



const PlanDetailModal = ({ isModalOpen, setIsModalOpen, storeSubscriptionPlan, postSubscription, postPayuSubscription, hoursCount, countingHours, postCashfreeOrder, user, setSubscriptionSelectedTab, userDetails, getUserProfileDetails }) => {
    const [price, setPrice] = useState(null)
    const [payLoader, setPayLoader] = useState(false);
    const payuWindowRef = useRef(null);
    const pendingPaymentRef = useRef(null);
    const history = useHistory();
    // PayU refuses an order without a billing address, so a profile missing it (or the email) is
    // completed through this modal before the order is created.
    const [isPaymentDetailsModal, setIsPaymentDetailsModal] = useState(false);
    const paymentDetailsRef = useRef(null);

    useEffect(() => {
        if (!userDetails?.id) getUserProfileDetails();
    }, []);
    // console.log("pricesss", price);
    useEffect(() => {
        setPrice(parseFloat(storeSubscriptionPlan?.price));
    }, [])

    const successCallback = () => {
        setIsModalOpen(false)
        setSubscriptionSelectedTab('Broadcast')
        history.push('/subscriptions')
    }
    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        hoursCount(1)
    };

    const handleSuccess = () => {
        setIsModalOpen(false)
        hoursCount(1)
    }

    useEffect(() => {
        const checkPaymentWindowClosed = () => {
            if (pendingPaymentRef.current && payuWindowRef.current?.closed) {
                const object = pendingPaymentRef.current;
                pendingPaymentRef.current = null;
                setPayLoader(true);
                postPayuSubscription(object, () => setPayLoader(false), successCallback);
            }
        };
        window.addEventListener('focus', checkPaymentWindowClosed);
        document.addEventListener('visibilitychange', checkPaymentWindowClosed);
        const pollTimer = setInterval(checkPaymentWindowClosed, 1000);
        return () => {
            window.removeEventListener('focus', checkPaymentWindowClosed);
            document.removeEventListener('visibilitychange', checkPaymentWindowClosed);
            clearInterval(pollTimer);
        };
    }, []);

    const handlePayNow = (price) => {
        if (!paymentDetailsRef.current && getMissingPaymentDetails(userDetails).isMissing) {
            setIsPaymentDetailsModal(true);
            return;
        }
        proceedToPayNow(price, paymentDetailsRef.current);
    };

    const proceedToPayNow = (price, paymentDetails, savePromise) => {
        // Opened inside the click so the browser does not block it; it waits on the loading page.
        payuWindowRef.current = openPayuLoadingWindow(PAYU_WINDOW_NAME);
        setPayLoader(true);
        if (!savePromise) {
            createOrder(price, paymentDetails);
            return;
        }
        // The address has to be on the profile before the order is created.
        savePromise.then(() => createOrder(price, paymentDetails)).catch(() => {
            setPayLoader(false);
            if (payuWindowRef.current && !payuWindowRef.current.closed) {
                payuWindowRef.current.close();
            }
        });
    };

    const createOrder = (price, paymentDetails) => {
        const amount = parseFloat(price) * countingHours
        const gst = parseFloat(price) * countingHours * 0.18;
        const amountGst = (amount + gst).toFixed(2);
        let params = {
            orderAmount: amountGst,
            orderCurrency: 'INR',
            flow: 'broadcast',
            userHours: storeSubscriptionPlan?.userHours,
            finalCost: amountGst,
            tax: gst,
            planCost: amount,
            discount: 0,
            netCostExTaxes: 0,
            repeat: countingHours,
            customerDetails: {
                customer_id: user?.id?.toString() || null,
                customer_name: user?.name || null,
                customer_email: paymentDetails?.email || userDetails?.email || user?.email || null,
                customer_phone: user?.phone?.toString() || null,
                customer_address: formatBillingAddress(paymentDetails?.address || userDetails?.basicprofile?.currentAddress) || null
            }
        };
        pendingPaymentRef.current = {
            userHours: storeSubscriptionPlan?.userHours,
            finalCost: amountGst,
            tax: gst,
            planCost: amount,
            discount: 0,
            netCostExTaxes: 0,
            repeat: countingHours,
            isTest: true,
        };
        // postCashfreeOrder(params, (response) => openCashFree({...response,amountGst,gst,amount}));
        postCashfreeOrder(params, (response) => {
            setPayLoader(false);
            // The order id is generated by the backend and comes back as txnid, so it can only be
            // attached once the order exists. Treat a response without one as a failure: the
            // poller above could not confirm the payment without it.
            if (response?.txnid) {
                pendingPaymentRef.current = { ...pendingPaymentRef.current, orderId: response.txnid };
                redirectToPayU(response, PAYU_WINDOW_NAME);
            } else {
                pendingPaymentRef.current = null;
                if (payuWindowRef.current && !payuWindowRef.current.closed) {
                    payuWindowRef.current.close();
                }
            }
        });
    };

    const openCashFree = (response) => {
        const cashfree = Cashfree({
            mode: Api._headers?.orgurl === "test.aulas.in" ? "sandbox" : "production",
            // other configuration options
        });
        let checkoutOptions = {
            paymentSessionId: response.payment_session_id,
            redirectTarget: "_modal",
        }
        cashfree.checkout(checkoutOptions).then(function (result) {
            if (result.error) {
                alert(result.error.message)
            }
            if (result?.paymentDetails?.paymentMessage) {
                let object = {
                    userHours: storeSubscriptionPlan?.userHours,
                    finalCost: response.amountGst,
                    tax: response.gst,
                    planCost: response.amount,
                    discount: 0,
                    netCostExTaxes: 0,
                    repeat: countingHours,
                    orderId: response.order_id,
                }
                handleSuccess()
                postSubscription(object, () => {}, successCallback)
            }
        });
    }

    return (
        <>
            <Modal
                centered
                className="modal-round-corner"
                visible={isModalOpen}
                onCancel={handleCancel}
                onOk={handleOk}
                footer={null}

            >
                <div style={{ fontSize: "21px", fontFamily: "Roboto", fontWeight: "bold", textAlign: "center", marginTop: "20px" }}>Plan Details</div>
                <div style={{ width: "95%", marginLeft: '10px' }}>
                    <div style={{ display: "flex", marginTop: "25px" }}>
                        <div style={{ fontWeight: '700', fontSize: 35, fontFamily: "PT-Serif" }}>{storeSubscriptionPlan?.userHours}</div>
                        <div style={{ fontWeight: '700', fontSize: 21, fontFamily: "PT-Serif", marginTop: "15px", marginLeft: "8px" }}>User Hours</div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                        <div style={{ color: "#636363", fontWeight: 500, fontFamily: "Roboto" }}>Price</div>
                        <div style={{ color: "#636363", fontWeight: 500, fontFamily: "Roboto", marginRight: "45px" }}>Quanities</div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", }}>
                        <div style={{ fontSize: 13, fontFamily: "Roboto" }}> ₹ {storeSubscriptionPlan?.price}</div>
                        <div>
                            {console.log("AA-countingHours", countingHours)}
                            <Input
                                style={{ width: "100px", }}
                                type="number"
                                defaultValue={"1"}
                                value={countingHours}
                                onChange={(e) => {
                                    if (e.target.value === 0) {
                                        console.log("AA-countingvalue", e.target.value);
                                        e.target.value = 1;
                                    }
                                    hoursCount(parseInt(e.target.value))
                                }}
                                prefix={<AiOutlineMinus style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        if (countingHours - 1 > 0) {
                                            hoursCount(parseInt(countingHours = countingHours - 1))
                                        }
                                    }}
                                />}
                                suffix={<AiOutlinePlus style={{ cursor: "pointer" }}
                                    onClick={() => { hoursCount(parseInt(countingHours = countingHours + 1)) }}
                                />}
                            />
                        </div>

                    </div>
                    <div>
                    </div>
                    <div style={{ fontSize: "12px", fontFamily: "Roboto", marginTop: "15px" }}>Amount details</div>
                </div>

                <div
                    style={{
                        marginTop: "25px",
                        marginLeft: "10px",
                        borderRadius: "6px",
                        alignItems: "center",
                        Width: 170,
                        height: 120,
                        border: "1px solid #E6E6E6",
                        backgroundColor: "#FFFFFF",
                    }}>
                    <div style={{ width: "95%", marginLeft: '10px' }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                            <div style={{ fontFamily: "Roboto", fontSize: "13px" }}>Subtotal</div>
                            <div style={{ fontFamily: "Roboto", fontSize: "13px", }}> ₹ {countingHours > 0 ? storeSubscriptionPlan?.price * countingHours : 0}</div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                            <div style={{ fontFamily: "Roboto", fontSize: "13px", }}>IGST</div>
                            <div style={{ fontFamily: "Roboto", fontSize: "13px", }}>+ ₹ {parseFloat((0.18 * parseFloat(countingHours > 0 ? storeSubscriptionPlan?.price * countingHours : 0)).toFixed(2))}</div>
                        </div>
                        <div style={{ borderBottom: "1px solid #E6E6E6 ", marginTop: "8px" }}></div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ color: "#191919", fontFamily: "Roboto", fontSize: "13px", fontWeight: "700", marginTop: "10px" }}>Total payable</div>
                            <div style={{ color: "#191919", fontFamily: "Roboto", fontSize: "13px", fontWeight: "700", marginTop: "10px" }}>₹ {parseFloat(parseFloat(1.18 * parseFloat(countingHours > 0 ? storeSubscriptionPlan?.price * countingHours : 0)).toFixed(2))}</div>

                        </div>
                        <div style={{ borderBottom: "1px solid #E6E6E6 ", marginTop: "8px" }}></div>


                    </div>

                </div>
                <div style={{ width: "55%", display: "flex", justifyContent: "space-between", marginTop: "40px", marginLeft: "100px" }}>
                    <div >
                        <Button
                            disabled={payLoader}
                            style={{
                                borderRadius: "19px",
                                width: "120px",
                                height: "35px",
                                fontWeight: "500",
                                border: "1px solid #636363 ",
                                backgroundColor: "#FFFFFF",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "16px",
                                    color: "#636363 ",
                                    fontFamily: "Roboto",
                                    fontWeight: "bold",
                                }}
                                onClick={() => { if (!payLoader) handleCancel() }}
                            >
                                CANCEL
                            </div>
                        </Button>
                    </div>
                    <div style={{}}>
                        <Button
                            loading={payLoader}
                            disabled={!countingHours || countingHours === "" || countingHours === NaN || payLoader}
                            style={{
                                borderRadius: "19px",
                                width: "120px",
                                height: "35px",
                                fontWeight: "500",
                                border: "1px solid #636363 ",
                                backgroundColor: "#594099",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "16px",
                                    color: "#FFFFFF ",
                                    fontFamily: "Roboto",
                                    fontWeight: "bold",
                                }}
                                onClick={() => { if (!payLoader) handlePayNow(storeSubscriptionPlan?.price) }}
                            >
                                {!payLoader && "PAY"}
                            </div>
                        </Button>
                    </div>
                </div>
            </Modal>
            {isPaymentDetailsModal &&
                <PaymentDetailsModal
                    visible={isPaymentDetailsModal}
                    onCancel={() => setIsPaymentDetailsModal(false)}
                    onProceed={(details, savePromise) => {
                        paymentDetailsRef.current = details;
                        setIsPaymentDetailsModal(false);
                        proceedToPayNow(storeSubscriptionPlan?.price, details, savePromise);
                    }}
                />}
        </>
    );
};

const mapStateToProps = (state) => {
    const {
    } = state.digitalLibrary;
    const { countingHours } = state.profile;

    const { user } = state.session;
    const { userDetails } = state.profileNew;
    return {
        countingHours,
        user,
        userDetails,
    };
};

const mapDispatchToProps = (dispatch) => ({
    postSubscription: (object, callback, successCallback) => dispatch(postSubscription(object, callback, successCallback)),
    postPayuSubscription: (object, callback, successCallback) => dispatch(postPayuSubscription(object, callback, successCallback)),
    postCashfreeOrder: (params, callback) => dispatch(postCashfreeOrder(params, callback)),
    hoursCount: (res) => dispatch(hoursCount(res)),
    storeSubscription: (res) => dispatch(storeSubscription(res)),
    setSubscriptionSelectedTab: (tab) => dispatch(setSubscriptionSelectedTab(tab)),
    getUserProfileDetails: (callback) => dispatch(getUserProfileDetails(callback)),

    // setAulasCareChat: (chat) => dispatch(setAulasCareChat(chat))
});

export default connect(mapStateToProps, mapDispatchToProps)(PlanDetailModal);

// export default PlanDetailModal;

